import React from "react"
import { PageProps, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import { GatsbyImage } from "@wp/ui"
import Layout from "../components/Layout"
import "animate.css"
import { PurchaseButton } from "../components/header"
import Icon from "@mdi/react"
import { mdiArrowTopRight, mdiPlus, mdiMinus } from "@mdi/js"

type IndexPageData = {
  landingImg: GatsbyImage
  image1: GatsbyImage
  image2: GatsbyImage
  image3: GatsbyImage
  image4: GatsbyImage
  image5: GatsbyImage
  image6: GatsbyImage
  image7: GatsbyImage
  image8: GatsbyImage
  photographyImg: GatsbyImage
  lifestyleImg: GatsbyImage
  minimalImg: GatsbyImage
  magazineImg: GatsbyImage
}

const FAQ: React.FC<{}> = () => (
  <section id="faq">
    <div className="section-title">
      <h2 className="font-head font-xxs">Frequently asked Questions</h2>
      <p className="font-head font-xl">Do you have Questions?</p>
    </div>
    <div className="faq-container">
      <ul>
        <li>
          <input type="checkbox" id="faq1" />
          <label htmlFor="faq1" className="font-head font-md">
            <Icon path={mdiPlus} className="open" color="#000" size={0.85} />
            <Icon path={mdiMinus} className="close" color="#000" size={0.85} />
            How can I deploy my Writersprint Blog Template?
            <div className="content font-body font-md">
              You can deploy the template easily by following this link{" "}
              <a
                className="font-body font-md"
                target="_blank"
                rel="noreferrer noopnener"
                href="https://www.gatsbyjs.org/docs/deploying-and-hosting/"
              >
                https://www.gatsbyjs.org/docs/deploying-and-hosting/
              </a>
            </div>
          </label>
        </li>
        <li>
          <input type="checkbox" id="faq2" />
          <label htmlFor="faq2" className="font-head font-md">
            <Icon path={mdiPlus} className="open" color="#000" size={0.85} />
            <Icon path={mdiMinus} className="close" color="#000" size={0.85} />
            How can I get customer support?
            <div className="content font-body font-md">
              After purchasing the product, if you need any support you can send
              us a mail at{" "}
              <a
                className="font-body font-md"
                target="_blank"
                rel="noreferrer noopnener"
                href="mailto:inioluwwa4.is@gmail.com"
              >
                inioluwwa4.is@gmail.com
              </a>
            </div>
          </label>
        </li>
        <li>
          <input type="checkbox" id="faq3" />
          <label htmlFor="faq3" className="font-head font-md">
            <Icon path={mdiPlus} className="open" color="#000" size={0.85} />
            <Icon path={mdiMinus} className="close" color="#000" size={0.85} />
            Can I change components as I like?
            <div className="content font-body font-md">
              Yes, You can change any component as you like.
            </div>
          </label>
        </li>
        <li>
          <input type="checkbox" id="faq4" />
          <label htmlFor="faq4" className="font-head font-md">
            <Icon path={mdiPlus} className="open" color="#000" size={0.85} />
            <Icon path={mdiMinus} className="close" color="#000" size={0.85} />
            Would I recieve updates regularly?
            <div className="content font-body font-md">
              Yes, we will update the Writersprint Template regularly. We thrive
              to constantly improve our products
            </div>
          </label>
        </li>
      </ul>
    </div>
  </section>
)

const IndexPage: React.FC<PageProps<IndexPageData>> = ({ data }) => {
  const {
    landingImg,
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    photographyImg,
    minimalImg,
    lifestyleImg,
    magazineImg,
  } = data

  return (
    <Layout>
      <main id="home" className="page-container">
        <section id="landing">
          <div className="underlay">
            <Img fluid={landingImg.childImageSharp.fluid} />
          </div>
          <div className="preview preview-left">
            <div className="img-1 img">
              <Img fluid={image1.childImageSharp.fluid} />
            </div>
            <div className="img-2 img">
              <Img fluid={image2.childImageSharp.fluid} />
            </div>
            <div className="img-3 img">
              <Img fluid={image3.childImageSharp.fluid} />
            </div>
            <div className="img-4 img">
              <Img fluid={image4.childImageSharp.fluid} />
            </div>
          </div>
          <div className="section-detail">
            <h1 className="font-head font-xl">
              Create a <em>blazing fast</em> modern blog powered by Gatsby
            </h1>
            <div className="purchase">
              <PurchaseButton>
                Purchase
                <Icon path={mdiArrowTopRight} color="#fff" size={0.85} />
              </PurchaseButton>
            </div>
          </div>
          <div className="preview preview-right">
            <div className="img-1 img">
              <Img fluid={image5.childImageSharp.fluid} />
            </div>
            <div className="img-2 img">
              <Img fluid={image6.childImageSharp.fluid} />
            </div>
            <div className="img-3 img">
              <Img fluid={image7.childImageSharp.fluid} />
            </div>
            <div className="img-4 img">
              <Img fluid={image8.childImageSharp.fluid} />
            </div>
          </div>
        </section>
        <section id="demos">
          <div className="section-title">
            <h2 className="font-head font-xxs">Blog Demos</h2>
            <p className="font-head font-xl">
              Beautiful <em>Designs</em> to Choose from
            </p>
          </div>
          <div className="demo-cards">
            <ul>
              <li>
                <a
                  href="https://writersprint-lifestyle.netlify.app"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Img fluid={lifestyleImg.childImageSharp.fluid} />
                  <p className="font-head font-md">Lifestyle Demo</p>
                </a>
              </li>
              <li>
                <a
                  href="https://writersprint-minimal.netlify.app"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Img fluid={minimalImg.childImageSharp.fluid} />
                  <p className="font-head font-md">Minimal Demo</p>
                </a>
              </li>
              <li>
                <a
                  href="https://writersprint-magazine.netlify.app"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Img fluid={magazineImg.childImageSharp.fluid} />
                  <p className="font-head font-md">Magazine Demo</p>
                </a>
              </li>
              <li>
                <a
                  href="https://writersprint-photography.netlify.app"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Img fluid={photographyImg.childImageSharp.fluid} />
                  <p className="font-head font-md">Photography Demo</p>
                </a>
              </li>
            </ul>
          </div>
        </section>
        <section id="features">
          <div className="section-title">
            <h2 className="font-head font-xxs">Awesome Features</h2>
            <p className="font-head font-xl">
              Focus on <em>Creating </em> Content and Less on Adding{" "}
              <em>Features </em>
            </p>
          </div>
          <div className="timeline">
            <ul>
              <li>
                <span className="list-num font-head font-xl">1</span>
                <div className="content">
                  <p className="font-head font-lg">Gatsby Js</p>
                  <p className="font-body font-md">
                    Gatsby is a free open source framework based on React for
                    developing blazing fast websites.
                  </p>
                </div>
              </li>
              <li>
                <span className="list-num font-head font-xl">2</span>
                <div className="content">
                  <p className="font-head font-lg">Typescript</p>
                  <p className="font-body font-md">
                    All components are written in typecript and have declared
                    typings.
                  </p>
                </div>
              </li>
              <li>
                <span className="list-num font-head font-xl">3</span>
                <div className="content">
                  <p className="font-head font-lg">Monorepo Support</p>
                  <p className="font-body font-md">
                    Lerna and Yarn workspace were used in managing multiple
                    packages.
                  </p>
                </div>
              </li>
              <li>
                <span className="list-num font-head font-xl">4</span>
                <div className="content">
                  <p className="font-head font-lg">Mailchimp Integration</p>
                  <p className="font-body font-md">
                    Helps add your audience to your Mailchimp list.
                  </p>
                </div>
              </li>
              <li>
                <span className="list-num font-head font-xl">5</span>
                <div className="content">
                  <p className="font-head font-lg">SEO Friendly</p>
                  <p className="font-body font-md">
                    Helps your blog rank higher/better in search engines
                  </p>
                </div>
              </li>
              <li>
                <span className="list-num font-head font-xl">6</span>
                <div className="content">
                  <p className="font-head font-lg">Built-in Components</p>
                  <p className="font-body font-md">
                    You are provided with reusable components such as layout,
                    headers, blogroll and more..
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </section>
        <FAQ />
      </main>
      <footer>
        <PurchaseButton
          className="purchase"
          href="https://"
          target="_blank"
          rel="noreferrer noopener"
        >
          Purchase
          <Icon path={mdiArrowTopRight} color="#000" size={0.85} />
        </PurchaseButton>
      </footer>
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query {
    landingImg: file(relativePath: { eq: "underlay6.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 25) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    image1: file(relativePath: { eq: "img-card1.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 15) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    image2: file(relativePath: { eq: "img-card2.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 15) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    image3: file(relativePath: { eq: "img-card3.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 15) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    image4: file(relativePath: { eq: "img-card4.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 15) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    image5: file(relativePath: { eq: "img-card5.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 15) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    image6: file(relativePath: { eq: "img-card6.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 15) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    image7: file(relativePath: { eq: "img-card7.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 15) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    image8: file(relativePath: { eq: "img-card8.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 15) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    photographyImg: file(relativePath: { eq: "photography-demo.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 50) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    lifestyleImg: file(relativePath: { eq: "lifestyle-demo.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 50) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    magazineImg: file(relativePath: { eq: "magazine-demo.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 50) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    minimalImg: file(relativePath: { eq: "minimal-demo.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 50) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
